<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 433.8 440.4"
    style="enable-background:new 0 0 433.8 440.4;"
    xml:space="preserve"
  >
    <g>
      <path
        d="M305.5,281.9l-5,10.7c-5.1,9.6-11.6,18.5-19.5,26.4c-21,21-49,32.6-78.7,32.6c-29.7,0-57.7-11.6-78.7-32.6
		c-21-21-32.6-48.9-32.6-78.7s11.6-57.7,32.6-78.7c12.6-12.6,27.7-21.7,44.1-27.1l8.6-2.5L157,42.9c-7.3,1.6-14.4,3.7-21.3,6.1
		l-1.8,0.5c0,0,0,0.1,0,0.1C55.9,77.3,0,151.7,0,239.2c0,111.1,90.1,201.2,201.2,201.2c86.1,0,159.5-54.1,188.3-130.1l-62.2-21
		L305.5,281.9z M328.3,366.2c-33.9,33.9-79,52.6-127,52.6s-93.1-18.7-127-52.6c-33.9-33.9-52.6-79-52.6-127s18.7-93.1,52.6-127
		c18.5-18.5,40.2-32.4,64-41.2c2.9,14.2,6.6,32.7,9.7,46.7c-14.9,6.6-28.6,15.9-40.4,27.7c-25.3,25.3-39.3,59-39.3,94.9
		s14,69.5,39.3,94.9c25.3,25.3,59,39.3,94.9,39.3s69.5-14,94.9-39.3c8.5-8.5,15.8-18.1,21.6-28.3l42.3,14.3
		C352.7,337.6,341.7,352.8,328.3,366.2z"
      />
      <path
        d="M232.6,0c-15.2,0-30,1.7-44.3,4.9l4.6,21.1l9.9,45.7l4.9,22.4c8.4-2,17.1-3.1,26-3.1c29.7,0,57.7,11.6,78.7,32.6
		c21,21,32.6,48.9,32.6,78.7c0,14.5-2.8,28.6-8,41.6l21.7,7.4l41.8,14.1l20.4,6.9c8.4-22.1,13-46.1,13-71.1
		C433.8,90.1,343.7,0,232.6,0z"
      />
      <path
        d="M280.3,282.1c3.7,0,6.7-3,6.7-6.7v-102c0-3.7-3-6.7-6.7-6.7h-19.5c-3.7,0-6.7,3-6.7,6.7v102c0,3.7,3,6.7,6.7,6.7H280.3z"
      />
      <path
        d="M234.1,282.1c3.7,0,6.7-3,6.7-6.7V203c0-3.7-3-6.7-6.7-6.7h-19.5c-3.7,0-6.7,3-6.7,6.7v72.3c0,3.7,3,6.7,6.7,6.7H234.1z"
      />
      <path
        d="M161.6,229.4v45.9c0,3.7,3,6.7,6.7,6.7h19.5c3.7,0,6.7-3,6.7-6.7v-45.9c0-3.7-3-6.7-6.7-6.7h-19.5
		C164.7,222.7,161.6,225.7,161.6,229.4z"
      />
      <path
        d="M122.2,249.1c-3.7,0-6.7,3-6.7,6.7v19.5c0,3.7,3,6.7,6.7,6.7h19.5c3.7,0,6.7-3,6.7-6.7v-19.5c0-3.7-3-6.7-6.7-6.7H122.2z"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
